import AHTMonitoringComponent from "~/components/pages/supervisor/ahtmonitoring";

export default function AHTMonitoringPage() {
  return (
    <div>
      <AHTMonitoringComponent />
    </div>
  );
}
